import React from 'react'
import { GetCustomQuote } from 'App/Components/CustomForm/GetQuote'
export const GetQuotePageCustom = () => {
  return <GetCustomQuote />
}
